import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { LOGON_INFO, SERVER } from "../app.constants";


@Injectable()
export class StateTotalService {

    constructor(
        private _htc: HttpClient
    ) { }


    getBranchTotalList(branch: string, year: string, month: string) {
        return this._htc.get<[]>(SERVER.baseURL+'/state-total/'+branch+'/'+year+(month.length == 1 ? '0'+month : month)+'/');
    }


    getBranchTotalBill(branch: string, year: string, month: string) {
        return this._htc.get<[]>(SERVER.baseURL+'/state-bill/'+branch+'/'+year+(month.length == 1 ? '0'+month : month)+'/'+LOGON_INFO.USER_ID);
    }


    // fetchStateTotalList(): Promise<any> {
    //     return new Promise((resolve, reject) => {
    //         this._htc.get<[]>(SERVER.baseURL+'/state-total/'+LOGON_INFO.COMP_ID+'/202303/')
    //             .subscribe(
    //                 data => {
    //                     const totalList: TotalStatement[] = data;

    //                     let allTotalList: any[] = [];
    //                     const filterArray = totalList.filter(obj => obj.parent_comp_name === '㈱大興').map(obj => obj.comp_name);
    //                     const daikoCompname = filterArray.filter((item, index) => filterArray.indexOf(item) === index);
    //                     const daikoCompCount = daikoCompname.length;

    //                     if (data.length > 0) {
    //                         for(let i=0; i<data.length; i++) {

    //                         }
    //                     }
    //                     resolve(null);
    //                 }
    //                 ,error => {
    //                     reject(null);
    //                 }
    //             )
    //     });
    // }
}


export class TotalStatement {
    id: number;
    billing_comp: string;
    customer_comp?: string;
    site_name?: string;
    parent_comp_name: string;
    comp_name: string;
    product_category: string;
    total_amount: number;
    total_margin: number;
}


export class TotalBill {
    billing_comp: string;
    customer_comp: string;
    billing_charge: number;
    collateral_import: number;
    collateral_import_fuel: number;
    collateral_import_tokyo: number;
    collateral_import_metro: number;
    collateral_import_sapporo: number;
    collateral_import_sendai: number;
    collateral_import_chiba: number;
    collateral_import_asaka: number;
    collateral_import_work: number;
}


export class TotalBillNew {
    billing_comp: string;
    customer_comp: string;
    import_name: string;
    // comp_name: string;
    charge: number;
}



// WEBPACK FOOTER //
// ./src/app/statement/state-total.service.ts